import React, { useState } from "react";
import {
  Button,
  FlexRowBetween,
  Input,
  Label,
  PopupForm,
} from "../common/Style";
import { useForm } from "react-hook-form";
import { CFV } from "../common/others/Functions";
import OpacityLoading from "../common/loader/OpacityLoading";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { add } from "../../store/reducers/efratReducer";
import GCalendar from "../common/calendar/Calendar";
import GenericModal from "../common/modals/GenericModal";

const AddUser = ({ init }) => {
  const dispatch = useDispatch();
  const { usersLoading } = useSelector((state) => state.userReducer);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [showCalendar, setShowCalendar] = useState(null);
  const [date, setDate] = useState(new Date());

  const handleSetDate = (e) => {
    let date1 = e;
    date1.setHours(20);
    setDate(date1);
  };

  const onSubmit = async (data) => {
    const body = {
      ...data,
      date: date.toISOString(),
    };
    dispatch(add(body)).then((res) => {
      if (!res.payload?.error) {
        toast.success("הפעולה בוצעה בהצלחה");
        init();
      } else toast.error(res.payload?.error);
    });
  };

  return (
    <PopupForm
      onClick={(e) => e.stopPropagation()}
      onSubmit={handleSubmit(onSubmit)}
      className="animate__animated animate__fadeIn"
    >
      <div
        style={{
          width: "90%",
          margin: "15px auto",
        }}
      >
        <FlexRowBetween>
          <div style={{ width: "35%" }}>
            <Label>שם האישה</Label>
            <Input
              type="text"
              {...register("brideName", {
                required: true,
                minLength: 0,
                maxLength: 50,
              })}
            />
            {CFV("brideName", "בין 2 ל 20 תווים", errors)}
          </div>
          <div style={{ width: "35%" }}>
            <Label>שם הגבר</Label>
            <Input
              type="text"
              {...register("groomName", {
                required: true,
                minLength: 0,
                maxLength: 50,
              })}
            />
            {CFV("groomName", "בין 2 ל 20 תווים", errors)}
          </div>
        </FlexRowBetween>
        <FlexRowBetween style={{ alignItems: "center" }}>
          <div style={{ width: "45%" }}>
            <Label>נייד אישה</Label>
            <Input
              {...register("bridePhone", {
                required: true,
                pattern: /^[0]{1}[5]{1}[0-9]{8}$/,
              })}
            />
            {CFV("bridePhone", "פורמט מספר פלאפון לא חוקי", errors)}
          </div>
          <div style={{ width: "45%" }}>
            <Label>תאריך האירוע</Label>
            <Input
              onClick={() => setShowCalendar(true)}
              value={date
                .toISOString()
                .replace(/T.*/, "")
                .split("-")
                .reverse()
                .join("/")}
              onChange={() => {}}
              type={"text"}
            />
            <div style={{ height: "20px" }} />
          </div>
        </FlexRowBetween>

        <FlexRowBetween style={{ marginTop: "50px" }}>
          <Button style={{ width: "100%" }}>הוספה</Button>
        </FlexRowBetween>
      </div>

      {usersLoading && <OpacityLoading />}

      {showCalendar && (
        <GenericModal
          init={setShowCalendar}
          div={
            <GCalendar
              setDate={handleSetDate}
              date={date}
              init={setShowCalendar}
            />
          }
        />
      )}
    </PopupForm>
  );
};

export default AddUser;
